import { useFragment } from '@apollo/client';
import type { AccountPlanAndTrialInfoFragment } from '@frameio/graphql-client/generated';
import { AccountPlanAndTrialInfo } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '../contexts';

export function useIsEnterpriseSubscriber(): boolean {
  const accountId = useActiveAccountId() ?? '';
  const { complete, data } = useFragment<AccountPlanAndTrialInfoFragment>({
    fragment: AccountPlanAndTrialInfo,
    fragmentName: 'AccountPlanAndTrialInfo',
    from: {
      __typename: 'Account',
      id: accountId,
    },
  });

  const isEnterpriseSubscriber =
    data?.subscription?.plan?.tier === 'ENTERPRISE';

  return complete ? isEnterpriseSubscriber : false;
}
